import { Box, Button, MobileStepper, Stack, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DashboardWidgetNav = ({
 totalPages,
 currentPage,
 setCurrentPage,
}: {
 totalPages: number;
 currentPage: number;
 setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}) => {
 const theme = useTheme();
 const { t } = useTranslation();

 const handlePreviousPage = () => {
  setCurrentPage((prev) => (prev <= 1 ? totalPages : prev - 1));
 };

 const handleNextPage = () => {
  setCurrentPage((prev) => (prev >= totalPages ? 1 : prev + 1));
 };

 return (
  totalPages > 1 && (
   <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    spacing={2}
   >
    <MobileStepper
     variant="dots"
     steps={totalPages}
     position="static"
     activeStep={currentPage - 1}
     elevation={0}
     sx={{
      p: 0,
      boxShadow: 'none',
      backgroundColor: 'transparent',
      '& .MuiMobileStepper-dotActive': {
       backgroundColor: theme.palette.kemek.blue,
      },
     }}
     nextButton={<></>}
     backButton={<></>}
    />
    <Box sx={{ display: 'flex', gap: '12px' }}>
     <Button
      variant="outlined"
      size="small"
      color="primary"
      onClick={handlePreviousPage}
      sx={{ minWidth: '80px', height: '34px !important' }}
     >
      {t('global.pagination.previous')}
     </Button>
     <Button
      variant="outlined"
      size="small"
      color="primary"
      onClick={handleNextPage}
      sx={{ minWidth: '80px', height: '34px !important' }}
     >
      {t('global.pagination.next')}
     </Button>
    </Box>
   </Stack>
  )
 );
};

export default DashboardWidgetNav;
